<div class="mb-3">
	<label>
		<input type="checkbox" [(ngModel)]="expandFilename">
		Download with full underscored filename
	</label>
</div>
<div class="mb-3 row">
	<label class="col-md-4">Start Date (UTC):</label>
	<div class="col-md-8">
		<app-day-picker [(ngModel)]="startDate" (ngModelChange)="RefreshData()"></app-day-picker>
	</div>
</div>
<div class="mb-3 row">
	<label class="col-md-4">End Date (UTC):</label>
	<div class="col-md-8">
		<app-day-picker [(ngModel)]="endDate" (ngModelChange)="RefreshData()"></app-day-picker>
	</div>
</div>

@if (datafiles === undefined) {
<div class="loading-status">
	<div class="logo-spin"></div>
	Loading...
</div>
}

@if (datafiles && datafiles.length === 0) {
<div class="loading-status">
	No datafiles found.
</div>
}

@if (datafiles && datafiles.length > 0) {
<table class="log">
	<thead>
		<tr>
			<th>Filename</th>
			<th>Size</th>
			<th>File Type</th>
			<th>Import Date ▼</th>
		</tr>
	</thead>
	@for (datafile of datafiles; track datafile; let i = $index) {
	<tbody [class.dayspacer]="(datafiles.length > i + 1) && (datafile.imported.clone().startOf('day') > datafiles[i + 1].imported.clone().startOf('day'))">
		<tr>
			<td><a (click)="DownloadFile(datafile)" href="javascript:void(0)"><i class="icon-doc"></i> {{datafile.filename | truncatedfile}}</a></td>
			<td>{{ datafile.size | filesize }}</td>
			<td>{{ datafile.filetype }}</td>
			<td>{{ datafile.imported | datetime : "local" }}</td>
		</tr>
	</tbody>
	}
</table>
}